export default __webpack_public_path__ + "static/media/DSC05966.4e23c0d0.jpg";